import React from 'react';
import {
  closestCenter,
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';

import { SortableItem } from './SortableItem';

import { isMobile } from '../../../config-utils';

const sensor = isMobile() ? TouchSensor : MouseSensor;

export const SortableList = (props) => {
  const { items } = props;

  const sensors = useSensors(
    useSensor(sensor, {
      // Press delay of 500ms, with tolerance of 5px of movement
      activationConstraint: {
        delay: 500,
        tolerance: 3
      }
    })
    // useSensor(PointerSensor),
    // useSensor(KeyboardSensor, {
    //   coordinateGetter: sortableKeyboardCoordinates
    // })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = items.findIndex((item) => item.id === active.id);
      const newIndex = items.findIndex((item) => item.id === over.id);
      props.updateOrder(oldIndex, newIndex);
      return;
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      autoScroll={true}
    >
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {items.map((item) => (
          <SortableItem key={item.id} id={item.id}>
            {props.displayFunc(item)}
          </SortableItem>
        ))}
      </SortableContext>
    </DndContext>
  );
};
